import React from 'react';
import {
  Grid,
  Button,
  makeStyles,
  colors,
  CircularProgress,
} from '@material-ui/core';
import { Link } from 'react-router-dom';

import Routes from 'config/routes';

import Title from 'components/typography/Title';
import Description from 'components/typography/Description';

import VerifiedButton from 'components/buttons/VerifiedButton';
import SendVerificationEmailButton from 'components/buttons/SendVerificationEmailButton';

import useCreateAccountRequest from 'pages/create_account/useCreateAccountRequest';

const useStyles = makeStyles({
  button: {
    color: colors.grey[50],
    backgroundColor: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const RequestStep = ({ signUpForm, exitPage }) => {
  const {
    isLoading,
    hasFailed,
    isFormInvalid,
    tryAgain,
    hasFinished,
  } = useCreateAccountRequest(signUpForm);

  return (
    <Grid container style={{ marginTop: -32, marginBottom: 8 }}>
      {isFormInvalid && <InvalidForm></InvalidForm>}
      {hasFailed && <Failed tryAgain={tryAgain}></Failed>}
      {isLoading && <Loading></Loading>}
      {hasFinished && (
        <Finished signUpForm={signUpForm} exitPage={exitPage}></Finished>
      )}
    </Grid>
  );
};

const Finished = ({ signUpForm, exitPage }) => {
  return (
    <Grid container direction="column" spacing={1}>
      <Grid item container justify="center">
        <Title>Account created</Title>
      </Grid>

      <Grid item container justify="center" style={{ marginTop: 8 }}>
        <Description>
          We sent you a email <b>verification</b>
        </Description>
      </Grid>

      <Grid item container justify="center" style={{ marginTop: 24 }}>
        <VerifiedButton
          email={signUpForm.email}
          password={signUpForm.password}
          onVerified={exitPage}
        ></VerifiedButton>
      </Grid>

      <Grid item container justify="center" style={{ marginTop: 4 }}>
        <SendVerificationEmailButton
          message={'RESEND EMAIL'}
          isContained={false}
        ></SendVerificationEmailButton>
      </Grid>
    </Grid>
  );
};

const Loading = () => {
  return (
    <Grid container justify="center">
      <CircularProgress style={{ color: colors.red[400] }}></CircularProgress>
    </Grid>
  );
};

const Failed = ({ tryAgain }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item container justify="center">
        <Description>
          Account creation <b>failed</b>
        </Description>
      </Grid>

      <Grid item container justify="center">
        <Button onClick={tryAgain} className={classes.button}>
          Try again
        </Button>
      </Grid>
    </Grid>
  );
};

const InvalidForm = () => {
  const classes = useStyles();

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item container justify="center">
        <Description>
          It seems that create account form is <b>invalid</b>
        </Description>
      </Grid>

      <Grid item container justify="center">
        <Link to={Routes.createAccount()} style={{ textDecoration: 'none' }}>
          <Button className={classes.button}>Check data</Button>
        </Link>
      </Grid>
    </Grid>
  );
};

export default RequestStep;
